import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Params } from '@angular/router';
import { IconType } from '../../interfaces';

@Component({
  selector: 'un-country-card',
  templateUrl: './country-card.component.html',
  styleUrls: ['./country-card.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CountryCardComponent {
  @Input() countryCode: string;
  @Input() countryName: string;
  @Input() cover?: string | null;
  @Input() extraLink: string | string[];
  @Input() extraLinkQuery: Params;
  @Input() extraIconTheme: IconType;
  @Input() extra: string;
  @Input() extraIcon: string;
}
